import { mapGenericModalProperties } from '@legacy/common-ui-shared';
import { GenericModalSources } from '@legacy/common-ui-shared-interfaces';
import type {
  ProductData,
  StoreFunnelSettingsFields,
  StoreFunnelSettingsInterface,
} from '@innogy/feh/models';

export function mapStoreFunnelSettingsFields(
  funnelSettingsFromSitecore: StoreFunnelSettingsFields | null | undefined,
  productList?: ProductData[]
): StoreFunnelSettingsInterface | undefined {
  if (!funnelSettingsFromSitecore?.fields) {
    return undefined;
  }

  const {
    SuccessPage,
    OrderPage,
    ProductOverviewPage,
    GenericErrorModal,
    Integration,
    ProductCategory,
    ProductType,
    HidePrices,
  } = funnelSettingsFromSitecore.fields;

  return {
    id: funnelSettingsFromSitecore.id,
    productOverviewPage: ProductOverviewPage?.value,
    orderPage: OrderPage?.value,
    successPage: SuccessPage?.value,
    genericErrorModal: mapGenericModalProperties(
      GenericModalSources.GENERIC_ERROR_MODAL,
      GenericErrorModal?.fields
    ),
    apiIntegrationPath: Integration?.value,
    productCategory: ProductCategory?.value,
    productType: ProductType?.value,
    hidePrices: !!HidePrices?.value,
    ...(productList && { products: productList }),
  };
}
